
import { Component, Mixins } from "vue-property-decorator";
import { SalesRepFeedbackValue } from "@/interfaces/meeting/conference";
import SnackbarMixin from "./SnackbarMixin.vue";
import { sendActivity } from "@/services/api/meeting";
import { AxiosInstance } from "axios";
import { MeetingActivityKind } from "@/interfaces/meeting/details";

@Component
export default class SalesRepFeedbackMixin extends Mixins<SnackbarMixin>(
  SnackbarMixin
) {
  displayFeedbackDialog = false;
  selectedRadio!: SalesRepFeedbackValue | null;
  feedbackComment!: string;
  submitLoading = false;
  apiClient!: AxiosInstance;

  setSelectedRadio(value: SalesRepFeedbackValue) {
    this.selectedRadio = value;
  }

  setFeedbackComment(value: string) {
    this.feedbackComment = value;
  }

  resetFeedback() {
    this.submitLoading = false;
    this.displayFeedbackDialog = false;
    this.selectedRadio = null;
    this.feedbackComment = "";
  }

  async submitSalesRepFeedback() {
    this.submitLoading = true;
    await sendActivity(
      this.apiClient,
      MeetingActivityKind.MEETING_FEEDBACK_COMMENT,
      `Salesrep feedback given at ${new Date().toLocaleString()}`,
      { kind: this.selectedRadio, feedback: this.feedbackComment }
    );
    this.resetFeedback();
    this.showSnackbar("Meeting ended and feedback successfully submitted");
  }
}
